import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { CreditCard, Users, Eye, TrendingUp } from "lucide-react";

export default function Dashboard() {
  const [stats, setStats] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/api/v1/analytics/stats")
      .then(setStats)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const statCards = [
    { label: "Total Visits", value: stats?.totalVisits || 0, icon: Eye, color: "text-blue-500 bg-blue-50" },
    { label: "Today's Visits", value: stats?.todayVisits || 0, icon: TrendingUp, color: "text-green-500 bg-green-50" },
    { label: "Top Pages", value: stats?.topPages?.length || 0, icon: CreditCard, color: "text-primary bg-primary/10" },
    { label: "Countries", value: stats?.countries?.length || 0, icon: Users, color: "text-purple-500 bg-purple-50" },
  ];

  return (
    <div>
      <h1 className="text-2xl font-bold mb-6">Dashboard</h1>

      {loading ? (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className="bg-card rounded-xl border border-border p-5 animate-pulse">
              <div className="h-4 bg-muted rounded w-20 mb-3" />
              <div className="h-8 bg-muted rounded w-16" />
            </div>
          ))}
        </div>
      ) : (
        <>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            {statCards.map((s) => (
              <div key={s.label} className="bg-card rounded-xl border border-border p-5">
                <div className="flex items-center justify-between mb-3">
                  <span className="text-sm text-muted-foreground">{s.label}</span>
                  <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${s.color}`}>
                    <s.icon className="w-4 h-4" />
                  </div>
                </div>
                <p className="text-2xl font-bold text-foreground">{s.value.toLocaleString()}</p>
              </div>
            ))}
          </div>

          {stats?.topPages?.length > 0 && (
            <div className="bg-card rounded-xl border border-border p-5">
              <h2 className="font-semibold mb-4">Top Pages</h2>
              <div className="space-y-2">
                {stats.topPages.map((p: any, i: number) => (
                  <div key={i} className="flex items-center justify-between py-2 border-b border-border last:border-0">
                    <span className="text-sm text-foreground truncate flex-1">{p.page_url}</span>
                    <span className="text-sm font-medium text-muted-foreground ml-4">{p.count}</span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
}
